import * as React from 'react';
import { useEffect } from 'react';
import { Footer } from '../Components/Footer/Footer';
import styled from 'styled-components'
import { map, split } from 'lodash';
import { useContext } from 'react';
import { SettingsContext } from '../Context';
import { Input } from '../Components/SearchBar/SearchBar';
import { useState } from 'react';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto; 
    max-width: 800px;
    padding-bottom: 200px;
    @media (max-width: 767px){
        width: 95%;
    }
`

const Message = styled.span`
    color: white;
    font-size: 1.3em;
    line-height: 1.6em;
`
const Title = styled.span`
    margin-top: 2em;
    color: #888888;
    font-size: 1.8em;
    font-weight: bold;
    width: 100%;
`
const Select = styled.select`
    width: 100%;
    height: 3.5em;
    padding-left: 1em;
    border-radius: 4px;
    margin-top: 2em;
    border: ${(props: {hasError: boolean}) => props.hasError ? `2px solid red` : 'none'}
`

const TextArea = styled.textarea`
    margin-top: 2em;
    width: 100%;
    min-height: 100px;
    border-radius: 4px;
    border: ${(props: {hasError: boolean}) => props.hasError ? `2px solid red` : 'none'}
`

const Button = styled.button`
    border: 1px solid #cccccc;
    padding: 0.7em 3em;
    border-radius: 4px; 
    color: white;
    font-size: 1em;
    background-color: transparent;
    margin-top: 2em;
`

const Banner = styled.div`
    width: 100vw;
    height: 33.33vw; 
    max-height: 300px;
    max-width: 2600px;
    overflow: hidden;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), transparent 75%);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: 3em;
    letter-spacing: 0.6em;
    font-weight: 100;
    font-family: Lato, sans-serif;

    @media (max-width: 767px){
        font-size: 2em;
        font-weight: 400;
        letter-spacing: 2vw;
    }

    @media (max-width: 479px){
        font-size: 1.4em;
    }
`

export const ContactUs = () => {
    const {locale} = useContext(SettingsContext)
    const [name, setName] = useState("")
    const [message, setMessage] = useState("")
    const [ email, setEmail] = useState("")
    const [selection, setSelect] = useState("")

    const [nameError, setNameError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [selectError, setSelectError] = useState(false)
    const [messageError, setMessageError] = useState(false)
    
    const onMessage = (e) => {
        setMessage(e?.target?.value)
    }

    const onSelect = (e) => {
        setSelect(e?.target?.value)
    }




    const onSubmit = () => {
        if(name === ""){
            alert(locale.contactUsNameError)
            setNameError(true)
            return
        }

        setNameError(false)
        if(selection === locale.selectOne || !selection || selection === ""){
            alert(locale.contactUsSelectError)
            setSelectError(true)
            return
        }
        setSelectError(false)
        if(message === ""){
            alert(locale.contactUsMessageError)
            setMessageError(true)
            return
        }
  
        setMessageError(false)
        let test = RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)

        if(email === "" || !test.test(email)){
            alert(locale.contactUsEmailError)
            setEmailError(true)
            return
        }
        setEmailError(false)
  
    }
    return(
        <div style={{
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}> 
            <Container>

                <Banner>
                    {locale.letsTalk}
                </Banner>

                <Message>
                    {map(split(locale.contactUsMain, "\n"), t => {return <span>{t}<br/></span> })}
                </Message>

                <Title>{locale.contactUsName}</Title>
                <Input 
                    hasError={nameError}
                    value={name}
                    onChange={setName}

                />
                <Title>{locale.contactUsQuestion}</Title>
                <Select onChange={onSelect} hasError={selectError}>
                    <option value={locale.selectOne}> {locale.selectOne}</option>
                    <option value={locale.contactUsTypeGeneral} >{locale.contactUsTypeGeneral}</option>
                    <option value={locale.contactUsTypeOrders} >{locale.contactUsTypeOrders}</option>
                    <option value={locale.contactUsTypePrayer} >{locale.contactUsTypePrayer}</option>
                    <option value={locale.contactUsTypeSupport} >{locale.contactUsTypeSupport}</option>
                </Select>

                <Title>{locale.contactUsMessage}</Title>
                <TextArea
                    hasError={messageError}
                    value={message}
                    onChange={onMessage}
                />

                <Title>{locale.contactUsEmail}</Title>
                <Input 
                    hasError={emailError}
                    type={"email"}
                    value={email}
                    onChange={setEmail}
                />

                <Button onClick={onSubmit}>{locale.submit}</Button>

            </Container>
    
            <Footer />


        </div>
    )
}




